<template>
    <div>
      <action-bar>
      </action-bar>
        <main class="content">
            <div v-if="chapter">
                <h1>Kapitel bearbeiten<br>
                    <small class="text-muted">
                      <router-link
                        v-if="chapter.keyThemeId"
                        :to="{name: 'key-theme-chapter-list', params: {keyThemeId: chapter.keyThemeId}}" exact>
                        {{keyTheme ? keyTheme.name.text : ''}}
                      </router-link>
                      <router-link
                        v-if="chapter.dossierId"
                        :to="{name: 'dossier-edit', params: {dossierId: chapter.dossierId}}" exact>
                        {{dossier ? dossier.name.text : ''}}
                      </router-link>
                      <i class="fal fa-angle-right"></i>

                      {{chapter ? chapter.name.text : ''}}</small>
                </h1>
                <ul class="nav nav-tabs">
                  <li class="nav-item">
                      <router-link class="nav-link"
                                  :to="{name: 'synthesis-chapter-edit', params: {chapterId: $route.params.chapterId}}" exact>
                          Generelle Texte
                      </router-link>
                  </li>
                  <li class="nav-item">
                      <router-link class="nav-link"
                                  :to="{name: 'synthesis-sub-chapter-list', params: {chapterId: $route.params.chapterId}}" exact>
                          Unterkapitel
                      </router-link>
                  </li>
                </ul>
                <div class="tab-content">
                    <router-view class="tab-pane fade show active" :data="chapter" entity="chapter"/>
                </div>
            </div>
            <loading v-else></loading>
        </main>
    </div>
</template>
<script>
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },
  asyncComputed: {
    keyTheme () {
      if (this.chapter && this.chapter.keyThemeId) {
        return axios
          .get('/api/' + store.state.language + '/key_theme/' + this.chapter.keyThemeId)
          .then(({data}) => data.result)
      }
    },
    dossier() {
      if(this.chapter && this.chapter.dossierId) {
        return axios
          .get('/api/' + store.state.language + '/dossier/' + this.chapter.dossierId)
          .then(({data}) => data.result)
      }
    }
  },
  data() {
    return {
      chapter: null
    };
  },
  mounted() {
    axios
      .get(
        "/api/" +
          store.state.language +
          "/chapter/" +
          this.$route.params.chapterId
      )
      .then(({ data }) => {
        this.chapter = data.result;
      });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/admin/synthesis/chapter/Edit.vue